import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../../crt-route-config'

export const Route = createFileRoute(
  '/_auth/_modules/crt/pricing-excise/data-sources/consumer-rates',
)({
  staticData: toStaticData(CRT_ROUTES['/crt/pricing-excise/data-sources/consumer-rates']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
